import { languageService } from "../../../../Language/language.service";

export const addEditEntryTemplateFormSchema = {
  title: languageService("Add Template"),
  id: "addEditEntryTemplateFormSchema",
  stateTitle: {
    create: languageService("Add Template"),
    view: languageService("View Template"),
    edit: languageService("Edit Template"),
    delete: languageService(`Are you sure you want to delete the following Template?`),
  },
  sections: [
    {
      id: "basicInfoSection",
      disabledStates: ["delete", "view"],
      fields: [
        {
          id: "name", // required
          labelValue: languageService("Template Name"),
          required: true,
          col: 4,
        },
      ],
    },
    {
      id: "footerActionsSection",
      fields: [
        {
          id: "saveTemplate",
          type: "button",
          labelValue: languageService("Save"),
          action: "submit",
          callback: "saveTemplate",
          position: "footer",
          hiddenStates: ["edit", "delete", "view"],
          col: 6,
        },
        {
          id: "confirmDeleteTemplate",
          type: "button",
          labelValue: languageService("Confirm"),
          action: "submit",
          callback: "confirmDeleteTemplate",
          position: "footer",
          hiddenStates: ["create", "edit", "view"],
          col: 6,
        },
        {
          id: "updateTemplate",
          type: "button",
          labelValue: languageService("Update"),
          action: "submit",
          callback: "updateTemplate",
          position: "footer",
          hiddenStates: ["create", "delete", "view"],
          col: 6,
        },
        {
          id: "cancelTemplateDialog", // required
          type: "button", // required
          labelValue: languageService("Cancel"),
          hiddenStates: ["view"],
          callback: "cancelTemplateDialog",
          action: "simple",
          position: "footer",
          col: 6,
        },
        {
          id: "closeTemplateDialog", // required
          type: "button", // required
          labelValue: languageService("Close"),
          hiddenStates: ["create", "edit", "delete"],
          action: "cancel",
          position: "footer",
          col: 12,
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/HoursOfService/EntryTemplates/schemas/addEditEntryTemplateFormSchema.js